import React, { useContext } from 'react';
import NumberFormat from 'react-number-format';
import {
 BriefingContext,
} from '../../../../containers/campanhas/Briefing';
import {
	InvestmentQuestion,
	InvestmentValue,
	InvestmentSlider,
} from './style';

export default function index() {
    const {
        campaign,
	} = useContext(BriefingContext);

	const {
		campaignInvestment,
		setCampaignInvestment,
	} = campaign;

	return (
		<>
			<InvestmentQuestion>
				Selecione o valor que será investido em sua campanha:
			</InvestmentQuestion>
			<InvestmentValue value={campaignInvestment}>
				<NumberFormat
					displayType="text"
					thousandSeparator="."
					decimalSeparator=","
					decimalScale={2}
					fixedDecimalScale
					prefix="R$ "
					suffix="/mês"
					value={campaignInvestment}
					id="campaign-investment"
				/>
			</InvestmentValue>
			<InvestmentSlider
				min={800}
				max={10000}
				step={50}
				value={campaignInvestment}
				tooltip={false}
				onChange={value => setCampaignInvestment(value)}
			/>
		</>
	);
}
